module.exports = __webpack_public_path__ + "static/media/Placaj ceramic Klinker Modern Rustic.4063c1e7.jpg";